import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import activate from '../../../../assets/images/icons/activate.svg';
import busSlash from '../../../../assets/images/icons/busSlash.svg';
import busStar from '../../../../assets/images/icons/busStar.svg';
import edit from '../../../../assets/images/icons/edit.svg';
import suspend from '../../../../assets/images/icons/suspend.svg';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { HandleOpenChangeStatusModalI, MappedWorkplace } from '../../types';
import {
  Card,
} from './styles';

interface ListInterface {
  filteredList: MappedWorkplace[];
  handleOpenChangeStatusModal: (workplaceChangingStatusObject: HandleOpenChangeStatusModalI) => void;
}

export default function List({
  filteredList,
  handleOpenChangeStatusModal,
}: ListInterface) {
  const { permissions, isCustomer } = useGetGeneralAppData();
  const workplacesPermissions = permissions.find((x) => x.codPag === 4);

  return (
    <Container>
      <Row xs={1} md={2} lg={2}>
        {filteredList?.map((wp) => (
          <Col key={wp.id}>
            <OpacityAnimation delay={0.1}>
              <Card>
                <div className="info">
                  <div className="card-title">
                    <strong>{wp.name}</strong>
                    <small className={wp.active ? 'green' : 'orange'}>
                      {wp.active ? 'Ativo' : 'Inativo'}
                    </small>
                  </div>
                  <span>
                    Código: {wp.code}
                  </span>
                  <span>
                    Logradouro: {wp.streetName}
                  </span>
                  <span>
                    {wp.city} - {wp.uf}
                  </span>
                </div>
                <div className="actions">
                  {workplacesPermissions?.alterar && (
                    <>
                      <button
                        type="button"
                        onClick={() => handleOpenChangeStatusModal({
                          name: wp.name,
                          id: wp.id,
                          active: wp.active,
                        })}
                      >
                        {wp.active ? (
                          <img src={suspend} alt="suspend" title="Inativar Local de Trabalho" />
                        ) : (
                          <img src={activate} alt="trash" title="Reativar Local de Trabalho" />
                        )}
                      </button>
                      <Link to={`/workplaces/${wp.id}`}>
                        <img src={edit} alt="" title="Editar Local de Trabalho" className='primaryColor' />
                      </Link>
                      {!isCustomer && (
                        <>
                          <Link to={`/linesOperatorsExceptions/${wp.id}?type=wp&activeSidebar=Workplaces&returnLink=${encodeURIComponent('/workplaces')}`}>
                            <img src={busSlash} alt="" title="Linhas e operadoras de exceção" />
                          </Link>
                          <Link to={`/linesOperatorsBias/${wp.id}?type=wp&activeSidebar=Workplaces&returnLink=${encodeURIComponent('/workplaces')}`}>
                            <img src={busStar} alt="" title="Linhas e operadoras de bias" />
                          </Link>
                        </>
                      )}
                    </>
                  )}
                </div>
              </Card>
            </OpacityAnimation>
          </Col>
        )
        )}
      </Row>
    </Container>
  );
}
